/*
  Danger! Do not remove any comments from this file, generator will be broken!
 */

export const locale = {
  // __GENERATED_TRANSLATIONS__
  retargetingAudience: {
    listTitle: 'Retargeting audiences',
    listSubtitle: 'S2S audience files, rebuilt and served from S3.',
    createFormTitle: 'New audience',
    editFormTitle: 'Edit audience',
    menuItemName: 'Audiences',
    menuItemParentName: 'Retargeting',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    selectAtLeastOneCohort: 'Select at least one cohort',
    segmentNameRequired: 'Segment name is required for enabled cohorts',
    segmentNameTaken: 'This segment name is already used by another audience',
    segmentNameUsedBy: 'Segment is already used in audience: {titles}',
    table: {
      id: 'ID',
      name: 'Name',
      segments: 'Segments',
      schedule: 'Schedule, UTC',
      lastRunStatus: 'Last run status',
      lastRunAt: 'Last run at, UTC',
      duration: 'Duration, sec',
      rows: 'Rows',
      file: 'File',
      size: 'Size, MB',
      status: 'Status',
      actions: 'Actions',
      searchPlaceholder: 'Name search',
      createdBy: 'created {date} by {name}',
    },
    schedule: {
      daily: 'Daily',
      manual: 'Manual only',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    runStatus: {
      pending: 'Pending',
      processing: 'Processing',
      done: 'Done',
      failed: 'Failed',
    },
    trigger: {
      schedule: 'Schedule',
      manual: 'Manual',
    },
    actionsTooltip: {
      runHistory: 'View run history',
    },
    field: {
      general: 'General',
      generalSubtitle: 'Name, schedule and destination.',
      formSubtitle: 'A saved rule that builds its Parquet file under a stable S3 key.',
      title: 'Title',
      schedule: 'Schedule',
      scheduleAt: 'Time, UTC',
      status: 'Status',
      s3Key: 'S3 object key',
    },
    rule: {
      title: 'Segments',
      subtitle:
        'Players included in the file set. Time windows shift daily, with each rebuild adding new users and removing converted or aged-out ones.',
      inactiveDaysEnabled: 'Exclude players active in the last',
      inactiveDaysSuffix: 'days (deposits, bets or revenue in player reports)',
      inactiveDaysTooltip:
        'A player counts as active on any day their daily report shows a deposit, a bet or revenue. Players who were active within this period are left out of the file. Applies to the Registered and Depositors segments — click-based segments have no player reports and are never filtered.',
      dedupeIpUa: 'Deduplicate by IP + UA',
    },
    fileColumns: {
      title: 'File columns',
      subtitle: 'Format: “Parquet — raw”. The following columns are included in the file.',
    },
    cohort: {
      reg_no_dep: {
        title: 'Registered, no deposit',
        description: 'Players with a registration and no first deposit yet.',
        withinDaysLabel: 'Registered within last, days',
      },
      depositors: {
        title: 'Depositors',
        description: 'Players with at least one deposit (FTD date set).',
        withinDaysLabel: 'Last deposit within, days',
      },
      clicks_no_reg: {
        title: 'Clicks without registration',
        description: 'Visitors who clicked but never registered. Limited to the click retention window (2-4 months).',
        withinDaysLabel: 'Click within last, days',
      },
      segmentName: 'Segment name',
    },
    scope: {
      title: 'Scope',
      subtitle: 'Narrow the audience by advertiser, offer, geo and traffic. Empty field = no restriction.',
      advertiser: 'Advertiser',
      offer: 'Offer',
      country: 'Country',
      actualCountry: 'Actual country',
      partner: 'Partner',
      partnerGroup: 'Partner group',
      stream: 'Stream',
      trafficSource: 'Traffic source',
      paymentModel: 'Payment model',
      autoAddGroupPartners: 'Automatically add new partners connected to selected groups to this audience',
      autoAddGroupPartnersTooltip:
        'Automatically add a partner to this audience when a new connection is created between the partner and a selected partner group in the scope.',
    },
    runs: {
      title: '{title} run history',
      started: 'Started, UTC',
      trigger: 'Trigger',
      triggeredBy: 'by {name}',
      duration: 'Duration',
      status: 'Status',
      rows: 'Rows',
      delta: 'Δ vs previous',
      size: 'Size',
      note: 'Note',
      ruleEditedNote: 'rule edited since last run',
      footerNote:
        'A failed run never touches the published file. The previous version stays under the same S3 key until the next successful rebuild.',
      runManually: 'Run manually',
      runManuallySuccess: 'Run started',
    },
  },
  retargetingAttribution: {
    statuses: {
      attributed: 'Attributed',
      pending: 'Pending',
      not_attributed: 'Not attributed',
      retargeting_click: 'Retargeting click',
    },
    cohorts: {
      clicks_no_reg: 'Clicks without registration',
      reg_no_dep: 'Registered, no deposit',
      depositors: 'Depositors',
    },
    tokenNotRecognised: 'token not recognised',
    retargetingClicksCount: '{count} retargeting click | {count} retargeting clicks',
    clicksCount: '{count} click | {count} clicks',
    last: 'last {date}',
    retargeting: 'Retargeting',
    attribution: 'Attribution',
    retargetingSegment: 'Retargeting segment',
    retargetingSegmentTooltip:
      'Click came from a retargeting campaign. Value is the audience segment name',
    attributionTooltip:
      'Attribution status of the retargeting click: whether the target event happened within the attribution window',
    playerRetargetingTooltip:
      'Summary of player retargeting clicks: Attributed if at least one click is attributed, Pending if an attribution window is still open, otherwise Not attributed',
    postbackRetargetingTooltip:
      'Attributed — this postback closed a retargeting attribution record. Retargeting click — postback click_id belongs to a retargeting click, but the event was not attributed',
    filterOptions: {
      only: 'Retargeting only',
      without: 'Without retargeting',
      has_clicks: 'Has retargeting clicks',
      fromRetargetingClick: 'From retargeting click',
    },
    clicksBlockTitle: 'Retargeting clicks',
    table: {
      clickedAt: 'Click date',
      rtSeg: 'Segment',
      cohort: 'Cohort',
      uiStatus: 'Status',
      event: 'Event',
      depositAmount: 'Amount of deps',
      partnerTitle: 'Partner',
      offerTitle: 'Offer',
    },
    // CPA-3455: Retargeting → Attribution report
    report: {
      listTitle: 'Retargeting attribution',
      listSubtitle: 'Retargeting clicks and target actions attributed to them within the time window',
      menuItemName: 'Attribution',
      unrecognisedToken: 'Unrecognised token',
      filters: {
        period: 'Period',
        audience: 'Audience',
        advertiser: 'Advertiser',
        segment: 'Segment',
        cohort: 'Cohort',
        partner: 'Partner',
        offer: 'Offer',
        status: 'Status',
      },
      groupBy: {
        label: 'Group by',
        off: 'Off',
        period: 'Period',
        audience: 'Audience',
        advertiser: 'Advertiser',
        segment: 'Segment',
        cohort: 'Cohort',
        partner: 'Partner',
        offer: 'Offer',
      },
      table: {
        clicks: 'Clicks',
        unique: 'Unique',
        players: 'Players',
        attributed: 'Attributed',
        attribution_cr: 'Attribution CR',
        new_regs: 'New regs',
        new_deps: 'New deps',
        amount_deps: 'Amount of deps',
        income: 'Income',
        spend: 'Spend',
        cfd: 'cFD',
        roi: 'ROI',
        average_check: 'Average check',
        pending: 'Pending',
      },
      tooltips: {
        clicks:
          'Retargeting clicks (clicks with the rt_uid parameter) with the click date in the selected period. Every click is counted, even if the same player clicked several times.',
        unique:
          'Unique clicks by the General report rule: no other click from the same IP and User-Agent on the same partner link within 24 hours.',
        players:
          'Distinct rt_uid values resolved to a player (or to the original click for the Clicks without registration cohort). Unrecognised tokens are not counted.',
        attributed:
          'Retargeting clicks followed by the target action within the attribution window. Each target action is attributed to one click only, the last click before the action. Attributed = New regs + New deps + attributed repeat deposits of the Depositors cohort.',
        attribution_cr:
          'Attributed / Clicks × 100. Calculated like Click/Reg on the General report, with attributed clicks instead of registrations. May grow while Pending clicks remain.',
        new_regs:
          'Attributed clicks followed by a registration (reg postback) within 24 hours of the click. Clicks without registration cohort only.',
        new_deps:
          'Attributed clicks followed by a first deposit (ftd postback) within 24 hours of the click. Registered, no deposit cohort only.',
        amount_deps: 'Sum of deposits from the Players Report rows for the days of the attributed events.',
        income: 'Sum of income from the same Players Report rows that form Amount of deps.',
        spend: 'Spend of the retargeting offer-partner for the click dates in the period.',
        cfd: 'Spend / New dep.',
        roi: '(Income − Spend) / Spend × 100.',
        average_check:
          'Amount of deps / number of attributed deposit records (first deposits and repeat-deposit days).',
        pending:
          'Retargeting clicks whose attribution window is still open: younger than 24 hours for the postback cohorts, or waiting for the Players report import for day D+1 for depositors.',
      },
    },
  },
  partnerCategories: {
    listTitle: 'Partner categories',
    editFormTitle: 'Partner category settings',
    menuItemName: 'Partner categories',
    categorySuffix: '{title} category',
    table: {
      id: 'ID',
      title: 'Title',
      color: 'Color',
    },
    settings: {
      id: 'ID',
      partnerGroup: 'Partner group',
      minSpend: 'Min spend',
      maxSpend: 'Max spend',
    },
  },

  entityLog: {
    listTitle: 'Change Log',
    menuItemName: 'Change Log',
    viewHistory: 'View changes history',
    titleSuffix: '| Change Log',
    systemUser: 'System',
    filters: {
      title: 'Logs filters',
      period: 'Period',
      user: 'User',
      entity: 'Entity',
      entities: 'Entity',
      updates: 'Update type',
      offerPartner: 'Offer-Partner',
      property: 'Property',
    },
    updates: {
      all: 'All updates',
      general: 'Offer general updates',
      op: 'Offer–Partners updates',
    },
    properties: {
      title: 'Title',
      active: 'Status',
      state: 'State',
      country: 'Country',
      paymentModel: 'Payment model',
      product: 'Product',
      partnersGroups: 'Partners groups',
      defaultPercent: 'Default percent',
      riskLevel: 'Risk level',
      sendInnerClickId: 'Click id usage',
      currency: 'Currency',
      stream: 'Stream',
      trafficSource: 'Traffic source',
      eventGroup: 'Event group',
      promoCodes: 'Promo Codes',
      tags: 'Tags',
      cost: 'Cost',
      offerCategory: 'Offer category',
      showOfferPartnerCategory: 'Show Offer-Partner category',
      costBaseline: 'Cost baseline',
      originalCountry: 'Original country',
      newCountry: 'New country',
      type: 'Rule type',
      dateFrom: 'Date from',
      dateTo: 'Date to',
      baseline: 'Baseline',
      subId: 'Sub ID',
      landing: 'Landing',
      maxDaysFromRegistration: 'Max days from registration',
      advertiserLink: 'Advertiser Link',
      uuid: 'UUID',
      partnerLink: 'Partner Link',
      teamName: 'Team Name',
      paymentDetails: 'Payment Details',
      affiliateId: 'Affiliate ID',
      affiliateIdTag: 'AffiliateID Tag',
      advertiser: 'Advertiser',
      apiToken: 'Token',
      enableApi: 'Spend import method',
      sheetId: "Spend's sheet id",
      group: 'Partner group',
      manager: 'Manager',
      position: 'Position',
      siteName: 'Site Name',
      siteId: 'Site ID',
      postback: 'Postback UUID',
      emails: 'Emails',
      userLogins: 'User logins',
      telegramContact: 'Telegram contact',
      partnersTags: 'Partner tags',
      subIdPlaceholder: 'Sub ID Placeholder',
      users: 'Partner',
      events: 'Postback URLs',
      name: 'Title',
      sendSubid: 'Resend Sub ID from Partner links',
      spreadsheet: 'spreadsheet',
      days: 'Days',
      bet: 'Bet',
      offer: 'Offer',
      partner: 'Partner',
    },
    entities: {
      offer: 'Offer',
      partner: 'Partner',
      offer_partner: 'Offer-Partner',
      offer_partner_landing: 'Landing',
      offer_status: 'Offer Status',
      op_cost_history: 'Cost history',
      op_bl_deposit_history: 'Bet requirement for qualification',
      op_bl_registration_history: 'Max days from registration',
      op_bl_period_history: 'Baseline period, days',
      op_country_requirement: 'Country matching requirement for qualification',
      partner_info: 'Additional Data',
      partner_manager: 'Manager',
      partner_stream: 'Stream',
      partner_group: 'Partner Group',
      partner_affiliate: 'Affiliate IDs',
      partner_event_group: 'Postback',
      spend_country_rule: 'Country replacement rule',
    },
    entityTypes: {
      all: 'All updates',
      general: 'General updates',
      offerPartners: 'Offer-Partners updates',
      allProperties: 'All properties',
      allEntities: 'All entities',
    },
    actions: {
      create: 'Created by {user}',
      update: 'Changed by {user}',
      delete: 'Deleted by {user}',
      remove: 'Removed by {user}',
    },
    actionLabels: {
      create: 'Created by',
      update: 'Changed by',
      delete: 'Deleted by',
      remove: 'Removed by',
    },
    table: {
      dateTimeUtc: 'Log date & time, UTC',
      activity: 'Activity',
      entity: 'Entity',
      property: 'Property',
      before: 'Value before',
      after: 'Value after',
    },
    propertyValues: {
      active: {
        true: 'Active',
        false: 'Inactive',
      },
    },
  },
  partnerSpendLog: {
    listTitle: 'Partners spend update history',
    menuItemName: 'Partners spend update history',
    activity: {
      create: 'Created',
      update: 'Changed',
    },
    filters: {
      title: 'Logs filters',
      logPeriod: 'Log period',
      user: 'User',
      spendPeriod: 'Spend period',
      partner: 'Partner',
      advertiser: 'Advertiser',
      country: 'Country',
      partnerGroup: 'Partner group',
      stream: 'Stream',
    },
    table: {
      dateTimeUtc: 'Log date & time, UTC',
      activity: 'Activity',
      method: 'Method',
      stream: 'Stream',
      advertiser: 'Advertiser',
      country: 'Country',
      property: 'Property',
      date: 'Date',
      before: 'Value before',
      after: 'Value after',
    },
    method: {
      createdBy: 'Created by {name}',
      changedBy: 'Changed by {name}',
      parsedFromSheet: 'Parsed from sheet',
      importedFromApi: 'Imported from 3rd-party API: {source}',
    },
  },
  linksGeneratorWorkflow: {
    listTitle: 'Link generator',
    listSubtitle: 'Bulk partner link generation wizard.',
    editFormTitle: 'Update traffic source',
    createFormTitle: 'Create traffic source',
    formFieldsBlockTitle: 'Main',
    generateLinks: 'Generate links',
    selectOffersTooltip: 'No rows selected — links will be generated for all offers in the list',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Link generator',
    bulkSelect: {
      button: 'Select offers',
      open: 'Open',
      openLimited: 'Open and Limited',
      openLimitedClosed: 'Open, Limited and Closed',
      note: "Offers without a status won't be selected.",
    },
    filters: {
      specificLandingsTooltip:
        'If no landing is selected, the default landings are used. If selected, only the selected landings are used to create the offer-partner landing.',
    },
    table: {
      id: 'ID',
      offer: 'Offer',
      advertiser: 'Advertiser',
      status: 'Status for traffic',
      cost: 'Cost',
      baseLine: 'Baseline',
      tooltipExists: 'Some offer-partner links for this offer and selected stream already exist and won’t be updated',
      tooltipMissingPostbacks:
        'Some offer-partner links for this offer and selected stream already have all the selected postback sets and won’t be updated',
      tooltipMissingLandings:
        'Some offer-partner links for this offer and selected stream already have all the selected landings and won’t be updated',
      maxDaysFromRegistration: 'Max days<br>from registration',
      betRequirement: 'Bet requirement<br>for qualification',
      countryMatching: 'Country matching<br>requirement for qualification',
    },
    steps: {
      step: 'Step',
      step1title: 'Parameters setup',
      step1subtitle: 'Select filters to load the offers list. Then select offers by clicking table rows.',
      step2title: 'Generated links',
      step2subtitle: 'Links have been generated. Notify the partner that everything is ready to start.',
    },
  },

  generatedLinks: {
    listTitle: 'Generated links',
    editFormTitle: 'Generated links',
    formFieldsBlockTitle: 'Main',
    restartWorkflow: 'Restart workflow',
    restartWorkflowDesc: 'Restart the generation workflow with the same parameters',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Generated links',
    table: {
      id: 'ID',
      partner: 'Title',
      traffic: 'Status',
      totalLinks: 'Total links',
      newLinks: 'New links',
      existedLinks: 'Existed links',
      updatedLinks: 'Updated links',
      existed: 'Existed',
      generated: 'Generated',
      updated: 'Updated',
      all: 'All',
      linkStatus: 'Link status:',
      linkStatusDesc:
        'Some links were not created because they already exist in the system for the selected parameters',
      user: 'User',
      generatedAt: 'Generation date & time, UTC',
      actions: 'Actions',
    },
    field: {
      name: 'Title*',
      active: 'Status',
    },
    notification: {
      title: 'Link generation completed!',
      newLinks: 'Newly generated links: {count}.',
      existedLinks: 'Already existing and not generated: {count}.',
      updatedOfferPartners: 'Offer-partners updated with new postbacks: {count}.',
      validationLogNotice:
        'Some offer-partner were not created because they did not pass validation. See the validation',
      validationLogLinkText: 'log file for details',
    },
    filters: {
      generationDate: 'Generation date',
    },
    form: {
      generatedAt: 'Generation date and time',
      partner: 'Partner',
      streams: 'Streams',
      mainPostback: 'Main postback',
      extraPostbacks: 'Extra postbacks',
      trafficSource: 'Traffic source',
      user: 'User',
      totalLinks: 'Total links',
      newLinks: 'New links',
      updatedOfferPartners: 'Updated links',
      existedLinks: 'Existed links',
      validationHits: 'Validation hits',
      validationHitsTooltip: 'Number of times validation blocked the creation of offer-partner due to rule violations',
      validationLogFile: 'Validation log file',
      offerPartners: 'Offer partners',
    },
  },
  budgetRequestsLog: {
    listTitle: 'Budget requests log',
    menuItemName: 'Budget requests log',
    table: {
      id: 'ID',
      createdBy: 'User',
      month: 'Month',
      createdAt: 'Import date & time, UTC',
      file: 'File',
      warnings: 'Warnings',
    },
    filters: {
      month: 'Month',
      importDate: 'Import date',
    },
  },
  budgetPlanner: {
    listTitle: 'Budget planner',
    groupBy: 'Group by',
    listSubtitle: 'Budget request and approval workflow covering CPA and Spend payment models.',
    importBtn: 'Import request',
    uploadTemplate: 'Upload template',
    modalImportTitle: 'Import request',
    modalImportSubtitle: 'Specify the month to which the request will be imported.',
    modalImportUploadLabel: 'Upload file*',
    modalImportUploadHintBold: 'Click to upload',
    modalImportUploadHint: 'or drag and drop',
    modalImportUploadFormat: 'Only .xlsx files up to {size} MB',
    modalImportRemoveFile: 'Remove file',
    notification: {
      importCanceledTitle: 'Import canceled due to issues in the file',
      importCanceledDescription:
        'The file contains data issues. Fix all issues before attempting the import again. Review the details here:',
      importAppliedWithIssuesTitle: 'Import applied with issues',
      importAppliedWithIssuesDescription: 'Some rows were skipped. Review the details here:',
      downloadFileLinkText: 'Download file',
    },
    table: {
      advertiser: 'Advertiser',
      country: 'Country',
      partner: 'Partner',
      trafficSource: 'Traffic source',
      paymentModel: 'Payment model',
      affiliateId: 'Affiliate ID',
      request: 'Request',
      approve: 'Approve',
      currentFact: 'Current fact',
      balance: 'Balance',
      status: 'Status',
      spendApprove: 'Spend/Approve',
      actions: 'Actions',
    },
    statuses: {
      no_request: 'No request',
      approved: 'Approved',
      need_approval: 'Need approval',
      not_approved: 'Not approved',
    },
    paymentModelOptions: {
      spend: 'Spend',
      cpa: 'CPA',
    },
    tableOptions: {
      default: 'Default',
      hasSpend: 'Only rows with spend',
      hasFtd: 'Only rows with FTD',
      hasRequest: 'Only rows with requests',
    },
    groupOptions: {
      advertiser: 'Advertiser -> Country -> Partner -> Traffic source',
      partner: 'Partner -> Advertiser -> Country -> Traffic source',
    },
    lockSetup: 'Lock setup',
    lockSetupDesc: 'Selected partner groups are not able to edit Request values.',
    requestLocked: 'Request locked',
    requestLockedDesc: 'This value is locked and cannot be edited or modified.',
    requestUnlocked: 'Request unlocked',
  },
  advertisersCost: {
    listTitle: "Advertiser's cost",
    listDesc: 'Read-only reference for advertiser’s cost.',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: "Advertiser's cost",
    errorEmpty: 'Advertiser, Country, and Status must be selected',
    errorDuplicate: 'This row exactly duplicates row(s) with ID = {id}',
    table: {
      mainData: 'Main data',
      id: 'ID',
      advertiser: 'Advertiser',
      country: 'Country',
      status: 'Status',
      actions: 'Actions',
      cpaBySources: 'CPA by sources, $',
      minDep: 'Min dep, $',
      cfd: 'Spend cFD, $',
      bl: 'BL',
      fb: 'FB',
      uac: 'UAC',
      ppc: 'PPC|(search)',
      aso: 'ASO',
      google: 'Google|(not search)',
      youtube: 'Youtube',
      inApp: 'InApp',
      seo: 'SEO',
    },
    statuses: {
      open: 'Open',
      limited: 'Limited',
      closed: 'Closed',
    },
  },
  paymentInvoices: {
    listTitle: 'Mira payment invoices',
    permissionTitle: 'Payment invoices',
    listSubtitle: 'List of invoices sent to the Mira CRM.',
    editFormTitle: 'Mira invoice data',
    createFormTitle: 'Create Mira invoice form',
    createFormDesc: 'Configuration of the spend applied to the Mira invoice.',
    editFormDesc: 'Invoice sent to Mira CRM.',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Mira payment invoices',
    table: {
      id: 'ID',
      period: 'Period',
      partner: 'Partner',
      country: 'Country',
      advertiser: 'Advertiser',
      trafficSource: 'Traffic source',
      stream: 'Stream',
      createdAt: 'Created, UTC',
      createdBy: 'Creator',
      status: 'Response from CRM',
      searchPlaceholder: 'Search Site ID',
    },
    field: {
      period: 'Period',
      partner: 'Partner',
      country: 'Country',
      advertiser: 'Advertiser',
      trafficSource: 'Traffic source',
      stream: 'Stream',
    },
    tabs: {
      table: 'Table',
      json: 'JSON',
    },
  },
  soloPaymentInvoices: {
    listTitle: 'Solo payment invoices',
    listSubtitle: 'List of invoices sent to the Solo CRM.',
    editFormTitle: 'Solo invoice data',
    createFormTitle: 'Create Solo invoice form',
    createFormDesc: 'Configuration of the spend applied to the Solo invoice.',
    editFormDesc: 'Invoice sent to Solo CRM.',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Solo payment invoices',
    table: {
      id: 'ID',
      period: 'Period',
      partner: 'Partner',
      country: 'Country',
      advertiser: 'Advertiser',
      trafficSource: 'Traffic source',
      stream: 'Stream',
      createdAt: 'Created, UTC',
      createdBy: 'Creator',
      status: 'Response from CRM',
      searchPlaceholder: 'Search Site ID',
      dealId: 'Deal ID',
    },
    field: {
      period: 'Period',
      partner: 'Partner',
      country: 'Country',
      advertiser: 'Advertiser',
      trafficSource: 'Traffic source',
      stream: 'Stream',
      dealId: 'Deal ID*',
    },
    tabs: {
      table: 'Table',
      json: 'JSON',
    },
  },
  newStreams: {
    listTitle: 'New streams',
    listSubtitle: 'New streams added to the system and offer-partners during the date range specified in the filter',
    menuItemName: 'New streams',
    table: {
      advertiser: 'Advertiser',
      siteId: 'Site ID',
      siteName: 'SiteName',
      affiliateId: 'AffiliateId',
      partner: 'Partner',
      geo: 'GEO',
      teamLead: 'TeamLead',
      manager: 'Manager',
      costModel: 'Cost model',
      type: 'Type',
      streamCreatedDate: 'Stream created date',
      dateAdded: 'Date added to first offer-partner',
      offerPartnerQty: 'Offer-Partners qty',
    },
    field: {
      name: 'Title*',
      active: 'Status',
    },
  },

  playerReportNotifications: {
    updating: 'The report cache is currently being updated. Data may be inaccurate.',
    updatingModal: 'The report cache is currently<br>being updated',
    updated: 'Cache updated. You can proceed with generating the report.',
    tableDeviation: 'The data in the report may have deviations due to the ongoing cache update',
    tableDeviationUpdate: ' update',
    tableUpdated1: 'The cache has been updated. Please ',
    reload: 'reload',
    tableUpdated2: ' the report.',
    tableUpToDate: 'The data in the report is up-to-date as of ',
    details: 'Details',
    reloadReport: 'Reload report',
    update_report_data: "Players' deposit data is currently being updated",
    update_base_line: "Players' baseline data is currently being updated",
    update_spend: 'Agent spend data is currently being updated',
    since: ' since ',
  },
  costsReport: {
    listTitle: 'Costs report',
    listSubtitle: 'Monthly cost analytics by stream, country, and payment model (export in xlsx).',
    editFormTitle: 'Traffic source settings',
    createFormTitle: 'Create traffic source form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Costs report',
    table: {
      id: 'ID',
      title: 'Title',
      active: 'Status',
      actions: 'Actions',
    },
    field: {
      name: 'Title*',
      active: 'Status',
    },
  },
  offerPartners: {
    copyLink: 'Copy link',
    listTitle: 'All links list',
    permissionTitle: 'Offer-Partners',
    viewOption: 'Viewing offer-partners & all links list',
    editOption: 'Editing offer-partners & all links list',
    editFormTitle: 'Update offer partner',
    createFormTitle: 'Create offer partner form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    uuidSearch: 'Landing UUID & Offer–Partner ID search',
    bulk: {
      updateCpaSettings: 'Update CPA settings',
      cancelCpaCosts: 'Cancel CPA costs',
      cancelCpaCostsDesc:
        'Choose the date from which costs will be reset to zero for the specified offer-partners. This applies to all players, including those who are already qualified.',
      applicableOnly:
        'Applies only to general CPA and CPA+RS offer-partners. Multigeo & others in the selection are skipped.',
      startingDate: 'Starting date',
      datePlaceholder: 'dd.mm.yyyy',
      active: 'Active',
      inactive: 'Inactive',
      fillCostOrBaseline: 'Fill in Cost or Baseline',
      dateFromLaterThanDateTo: 'Date from must not be later than date to',
      selectDateRange: 'Select the date range.',
      fillValue: 'Fill in the value.',
      selectValue: 'Select the value.',
      selectStartingDate: 'Select the starting date.',
    },
    streamExists: 'Stream already used in another offer for this country',
    offerStreamDuplicate: 'This stream is already selected in another offer-partner within the same offer.',
    offerStreamActivationError:
      'Offer-partner cannot be activated. One or more streams ({streams}) are selected in more than one offer-partner within the same offer ({offers}).',
    offerStreamDuplicateNotification:
      'Update cannot be submitted. One or more streams ({title}) are selected in more than one offer-partner within the same offer ({offer}).',
    trafficSourceExists: 'Traffic source already exists',
    trafficSourceNotification: 'Selected stream is already connected with another traffic source ({trafficSource})',
    streamExistsNotification:
      'The stream {stream} {siteId} cannot be submitted as it is already selected in another agent offer ({offer}) within the same country.',
    opExistsNotification:
      'This offer-partner cannot be submitted as its stream is already selected in another agent offer ({offer}) within the same country.',
    trafficChangeWarningTooltip: 'This offer-partner already has traffic data (clicks and/or registrations).',
    trafficChangeWarningTitle: 'Please review this change',
    trafficChangeWarningMessage:
      'This Offer–Partner already has traffic data (clicks and/or registrations). Changing the Offer, Partner, Stream, or Traffic Source affects existing statistics and reports. Please verify that this change is intentional before continuing.',
    copyAllLinks: 'Copy all partner links from this block to the clipboard',
    copyAllLandingTitles: 'Copy all landing titles from this block to the clipboard',
    copyPartnerLink: 'Copy partner link to the clipboard',
    copyLandingTitle: 'Copy landing title to the clipboard',
    copyAdvertiserLink: 'Copy advertiser link to the clipboard',
    deleteLanding: 'Delete this landing',
    menuItemParentName: 'Offer-Partner links',
    menuItemName: 'All links list',
    exportConfirmTitle: 'Export',
    exportConfirmDesc: 'Are you sure you want to export?',
    table: {
      id: 'ID',
      offer: 'Offer',
      partner: 'Partner',
      advertiser: 'Advertiser',
      country: 'Country',
      product: 'Product',
      stream: 'Stream',
      siteId: 'Site ID',
      trafficSource: 'Traffic source',
      promoCodes: 'Promo Codes',
      postback: 'Postback',
      paymentModel: 'Payment model',
      currency: 'Currency',
      cost: 'Cost',
      uuid: 'UUID',
      baseline: 'Baseline',
      baselinePeriod: 'Baseline period, days',
      maxDays: 'Max days from registr.',
      offerTags: 'Offer tags',
      offerCategory: 'Offer category',
      status: 'Status',
      partnerLink: 'Partner link',
      advertiserLink: 'Advertiser link',
      landing: 'Landing',
      subId: 'Sub ID',
      actions: 'Actions',
    },
    field: {
      name: 'Title*',
      active: 'Status',
    },
  },
  spendsParsingLog: {
    listTitle: 'Spend import log',
    editFormTitle: 'Update import log form',
    createFormTitle: 'Create import log form',
    formFieldsBlockTitle: 'Main',
    datePickerLabel: 'Select parsing date',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Spend import log',
    success: 'Success',
    warnings: 'Warnings',
    cron: 'Automated',
    user: 'User',
    importInitiator: 'Import initiator',
    searchPlaceholder: 'Data source search',
    modalDesc: 'There were issues during the parsing process:',
    table: {
      id: 'ID',
      partner: 'Partner',
      group: 'Group',
      dataSource: 'Data source',
      date: 'Import period',
      parse: 'Request date & time, UTC',
      status: 'Status',
      actions: 'Actions',
      originalResponse: 'Original response',
    },
    field: {
      name: 'Title*',
      active: 'Status',
    },
    importPeriod: 'Import period',
    requestDate: 'Request date',
  },

  cohortAnalysis: {
    listTitle: 'Cohort analysis',
    listSubtitle:
      'Metrics based on players who registered or deposited in the selected period, comparing their metrics over the interval from cohort start to target date.',
    editFormTitle: 'Update',
    createFormTitle: 'Create',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Cohort analysis',
    select: {
      firstDeposit: 'First deposit',
      firstDeposits: 'First deposits',
      regAndDep: 'Registration & Deposit',
      registration: 'Registration',
    },
    selectActivity: {
      all: 'All activities',
      firstDep: 'All FTD',
      registration: 'New Players',
    },
    filters: {
      targetDate: 'Target date',
      playersCohort: 'Players cohort',
    },
    table: {
      advertiser: 'Advertiser',
      partner: 'Partner',
      product: 'Product',
      country: 'Country',
      offer: 'Offer',
      siteId: 'Site ID',
      subId: 'Sub ID',
      clickId: 'Click ID',
      playerId: 'Player ID',
      landing: 'Landing',
      notUsedSpend: 'Spend without traffic',
      landingNotSelected: '<Landing not selected>',
      click_idNotSelected: '',
      traffic: 'Traffic |source',
      traffic_source: 'Traffic |source',
      trafficNotSelected: '<Traffic source not selected>',
      notSelected: 'Not selected',
      date: 'Period',
      actualCountry: 'Actual |country',
      registrations: 'New |reg',
      newDeposits: 'New deps,|{range}',
      allDeposits: 'All |deps',
      allDepositsTooltip:
        'Each deposit entry corresponds to a unique day on which the user made a deposit. The system does not retain data on multiple deposits made by the user within the same day.',
      regDep: 'Reg/Dep',
      deposits: 'Amount of all deps,|{range}',
      amount_newDeposits: 'Amount of |new dep',
      firstDepAmount: 'First dep |amount',
      amount_bets: 'Amount of bets,|{range}',
      avg_check: 'Average check |{range}',
      income: 'Income,|{range}',
      spend: 'Spend,|{range}',
      roi: 'ROI,|{range}',
      cfd: 'cFD,|{range}',
      actions: 'Actions',
    },
    tableTitle: {
      offer: 'Offers',
      partner: 'Partners',
      advertiser: 'Advertisers',
      click_id: 'Player IDs',
      site_id: 'Site IDs',
      date: 'Days',
      country: 'Countries',
      product: 'Products',
      landing: 'Landings',
      traffic_source: 'Traffic sources',
      playersQty: 'Players quantity:',
    },
  },
  cohortAnalysisCumulative: {
    listTitle: 'Cumulative cohort analysis',
    listSubtitle:
      'Cumulative version of Cohort analysis with cumulative sums for Average check, cFD, and ROI from cohort start to target date.',
    editFormTitle: 'Update',
    createFormTitle: 'Create',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Cumulative cohort analysis',
    select: {
      firstDeposit: 'First deposit',
      firstDeposits: 'First deposits',
      regAndDep: 'Registration & Deposit',
      registration: 'Registration',
    },
    selectActivity: {
      all: 'All activities',
      firstDep: 'All FTD',
      registration: 'New Players',
    },
    filters: {
      targetDate: 'Target date',
      playersCohort: 'Players cohort',
    },
    table: {
      advertiser: 'Advertiser',
      partner: 'Partner',
      product: 'Product',
      country: 'Country',
      offer: 'Offer',
      siteId: 'Site ID',
      subId: 'Sub ID',
      clickId: 'Click ID',
      playerId: 'Player ID',
      landing: 'Landing',
      notUsedSpend: 'Spend without traffic',
      landingNotSelected: '<Landing not selected>',
      click_idNotSelected: '',
      traffic: 'Traffic |source',
      traffic_source: 'Traffic |source',
      trafficNotSelected: '<Traffic source not selected>',
      notSelected: 'Not selected',
      date: 'Period',
      actualCountry: 'Actual |country',
      registrations: 'New |reg',
      newDeposits: 'New deps,|{range}',
      allDeposits: 'All |deps',
      allDepositsTooltip:
        'Each deposit entry corresponds to a unique day on which the user made a deposit. The system does not retain data on multiple deposits made by the user within the same day.',
      regDep: 'Reg/Dep',
      deposits: 'Amount of all deps,|{range}',
      amount_newDeposits: 'Amount of |new dep',
      firstDepAmount: 'First dep |amount',
      amount_bets: 'Amount of bets,|{range}',
      avg_check: 'Average check |{range}',
      income: 'Income,|{range}',
      spend: 'Spend,|{range}',
      roi: 'ROI,|{range}',
      cfd: 'cFD,|{range}',
      actions: 'Actions',
    },
    tableTitle: {
      offer: 'Offers',
      partner: 'Partners',
      advertiser: 'Advertisers',
      click_id: 'Player IDs',
      site_id: 'Site IDs',
      date: 'Days',
      country: 'Countries',
      product: 'Products',
      landing: 'Landings',
      traffic_source: 'Traffic sources',
      playersQty: 'Players quantity:',
    },
  },
  partnersSpendsTable: {
    listTitle: 'Partners spend',
    editFormTitle: 'Update partners spend form',
    createFormTitle: 'Create partners spend form',
    formFieldsBlockTitle: 'Main',
    adminOnlyAccess: 'Admin-only access',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    hasNoLinkedPartnerGroups:
      'Default percentage setup is not available. This partner is not linked to any partner group.',
    menuItemName: 'Partners spend',
    errorMessage:
      'No clicks, registrations, or deposits were recorded for this stream and country on the selected date.',
    blockedPeriodTooltip: 'Spend updates are already blocked for this month',
    spendBlockedTooltip: 'Spend editing is blocked for this month',
    decreasedTooltip: 'Decreased from {prev}% by {user} on {date} at {time} UTC.',
    updatePercentage: 'Update percentage',
    updatePercentageDesc: 'The entered percentage will replace the current values.',
    percentageSetup: 'Default percentage setup',
    percentageSetupDesc:
      'Sets the default percentage for the partner and group. It overrides the existing values, including those manually edited in cells.',
    allPeriod: 'All period',
    fromSelectedMonth: 'From selected month and further',
    tableView: 'Table view',
    default: 'Default',
    showRowsWithSpend: 'Show only rows with spend',
    showRowsWithFtd: 'Show only rows with FTD',
    showEmptyRows: 'Show empty rows (no clicks, registrations, deposits, spend)',
    showRowsWithUnsplitSpend: 'Rows with unsplit spend',
    noSegment: 'No segment',
    importedTooltip: 'Spend is imported for this stream-country',
    segmentNoSpendTooltip: 'Traffic with this segment exists, but no spend has been entered for it this month',
    weightedPercentTooltip: 'Weighted average of segment rows',
    table: {
      advertiser: 'Advertiser',
      stream: 'Stream',
      segment: 'Segment',
      offer: 'Offer',
      site_id: 'Site ID',
      country: 'Country',
      actions: 'Actions',
      total: 'Total',
      depSumSpend: 'DepSum/Spend',
      depSumSpendLine1: 'DepSum/',
      depSumSpendLine2: 'Spend',
      recommendedSpend: 'Recommended spend',
      recommendedSpendLine1: 'Recommended',
      recommendedSpendLine2: 'spend',
      recommendedSpendTooltip: "New deps × cFD (cFD is defined in the Advertiser's cost)",
      avgCommission: 'Average commission',
      avgCommissionLine1: 'Average',
      avgCommissionLine2: 'commission',
      avgCommissionTooltip: 'Weighted average – percentages are weighted by spend amount.',
    },
    field: {
      name: 'Title*',
      active: 'Status',
    },
  },
  spendBlocking: {
    btnLabel: 'Spend blocking',
    btnTooltip: 'Manage month-based spend editing restrictions for partner groups',
    title: 'Manage spend blocking',
    description: 'Block or unblock spend updating for specific partner groups and months.',
    lockedMonths: 'Locked months',
    month: 'Month',
    status: 'Status',
    lockedOn: 'Locked on',
    lockedBy: 'Locked by',
    action: 'Action',
    locked: 'Locked',
    unlock: 'Unlock',
    alert:
      'A partner user can update spend for the previous month only up to the 10th day of the current month, even if the month is not yet blocked here.',
    noLockedMonths: 'No locked months yet',
    addMonth: 'Add a month',
    addMonthSuffix: ' to block spend updating for this partner group.',
  },
  trafficSources: {
    listTitle: 'Traffic sources',
    editFormTitle: 'Traffic source settings',
    createFormTitle: 'Create traffic source form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Traffic sources',
    permissionName: 'Traffic sources filter',
    table: {
      id: 'ID',
      title: 'Title',
      type: 'Type',
      url: 'URL',
      typeOfAdvertisingId: 'Mira CRM Type of Advertising ID',
      trafficSourceId: 'Mira CRM Traffic Source ID',
      active: 'Status',
      actions: 'Actions',
      searchPlaceholder: 'Title, URL, Mira CRM IDs search',
    },
    field: {
      name: 'Title*',
      type: 'Type*',
      url: 'URL',
      typeOfAdvertisingId: 'Mira CRM Type of Advertising ID',
      trafficSourceId: 'Mira CRM Traffic Source ID',
      active: 'Status',
      descriptionForMiraCRM: 'Description for Mira CRM',
    },
    type: {
      main: 'Main',
      networks: 'Networks',
    },
  },

  playersReportsApi: {
    listTitle: 'Players reports (API)',
    listSubtitle: 'Date-based players activity data retrieved from a 3rd-party API.',
    editFormTitle: 'Players report (API)',
    createFormTitle: 'Create player form',
    menuItemName: 'Players reports (API)',
    apiManualRequest: "Manual players' data import",
    selectDate: 'Select the import period and Streams (optional) for a manual request to the 3rd-party API.',
    selectXlsx:
      'Upload a players report (.xlsx) for one date and one advertiser. Select the report date, the advertiser and Streams (optional).',
    importMethod: 'Import method',
    importMethodApi: 'Import from 3rd-party API',
    importMethodXlsx: 'Import from .xlsx',
    file: 'File',
    fileHint: 'Click to upload or drag and drop an .xlsx file',
    onlyXlsx: 'Only .xlsx files are supported.',
    reportDate: 'Report date',
    table: {
      searchPlaceholder: 'IDs search',
      reportDate: 'Report date',
      warnings: 'Warnings',
      requestFile: 'Warnings log file',
      requestedSiteIds: 'Request',
      response: 'Original response',
      lastRetryStatus: 'Last attempt status',
      currentRetryAttempt: 'Attempts',
      nextRetry: 'Next attempt, UTC',
      lastErrorMessage: 'Last error message',
      reimport: 'Reimport the report',
      retryHistory: 'Attempts',
      retryHistorySubtitle: 'A record of all import attempts with key details.',
      retryNumber: 'Attempt',
      retryDateTime: 'Date & time, UTC',
      importInitiator: 'Import initiator',
      retryStatus: 'Status',
      retryDetails: 'Details',
      importedObjects: 'Imported objects',
      source: 'Source',
      registrationDatePeriod: 'Registration date',
      firstDepositDatePeriod: 'First deposit date',
      lastAttempt:
        'No deposits were returned by the API. This is the fifth and final attempt for this report. To retry the import for this date, please delete the report and import it again.',
    },
  },
  landings: {
    listTitle: 'Landings',
    editFormTitle: 'Landing settings',
    createFormTitle: 'Create landing form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Landings',
    permissionName: 'Landings filter',
    table: {
      id: 'ID',
      title: 'Title',
      value: 'Value',
      subId: 'Sub ID',
      searchPlaceholder: 'Title, Value, Sub ID search',
      active: 'Status',
      actions: 'Actions',
    },
    field: {
      title: 'Title*',
      value: 'Value',
      subId: 'Sub ID',
      active: 'Status',
    },
  },
  budgetPlan: {
    listTitle: 'Budget plan',
    listSubtitle:
      'Planned vs actual partner budgets per advertiser, with prev-month spend, cFD-based prediction, and alerts.',
    editFormTitle: 'Update postback',
    createFormTitle: 'Create postback form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    showNoBudgetCountry: 'Show countries without any budget',
    menuItemName: 'Budget plan',
    table: {
      title: 'Advertiser & Country',
      budget: 'Planned budget',
      actual_budget: 'Actual budget',
      free_budget: 'Free budget',
      free_budget_percent: 'Free budget',
      prev_month_spend: 'Previous month spend',
      cfd: 'Current spend prediction',
      cfdDesc: 'Predicted from previous month’s cFD',
      warnings: 'Warnings',
      traffic_status: 'Traffic status',
      actions: 'Actions',
    },
    field: {
      name: 'Name*',
      placeholder: 'Sum*',
      active: 'Status',
    },
    trafficStatuses: {
      active: 'Active',
      pause: 'Pause',
      stop: 'Stop',
    },
    warning: {
      spendRise: 'Spend rise',
      overLimit: 'Overlimit',
      budgetDeficit: 'Budget deficit',
    },
  },
  partnerReport: {
    listTitle: 'Partners report',
    listSubtitle: 'Partners statistics in other partner groups',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Partners report',
    table: {
      title: 'Partners and groups',
      offer: 'Offer',
      total: 'New dep',
      actions: 'Actions',
    },
    field: {
      name: 'Name*',
      placeholder: 'Sum*',
      active: 'Status',
    },
  },

  roles: {
    listTitle: 'Roles',
    editFormTitle: 'Role settings',
    createFormTitle: 'Create role form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Roles',
    table: {
      id: 'ID',
      title: 'Title',
      active: 'Status',
      searchPlaceholder: 'Title search',
      actions: 'Actions',
    },
    field: {
      title: 'Title*',
    },
  },

  permissions: {
    userDesc: 'Setting up an access template for a role',
    descUserForm: 'Access setup for this user',
    viewing: 'Viewing',
    editing: 'Editing',
    editingDesc: 'Make any changes',
    viewingDesc: 'View data, but make no changes',
    adminFullAccess: 'Admin full access',
    groupView: 'Partner groups view',
    managersAccess: 'Managers access settings',
    request: 'Request',
    requestApprove: 'Request & approve',
    disabledInViewMode: 'Disabled in Viewing mode',
    logs: 'Logs',
    offerLogs: 'Offer logs',
    partnerLogs: 'Partner logs',
    offerPartnerLogs: 'Offer-Partner logs',
    partnerSpendLogs: 'Partners spend logs',
    spendImportLogs: 'Spend import logs',
    budgetRequestsLog: 'Budget requests log',
    retargeting: 'Retargeting',
    retargetingAttributionView: 'Retargeting attribution',
    retargetingAudienceView: 'Retargeting audiences (Viewing)',
    retargetingAudienceEdit: 'Retargeting audiences (Editing)',
    cpaSettingsBulkEdit: 'Mass CPA settings (Editing)',
  },
  partnerGroups: {
    listTitle: 'Partner groups',
    editFormTitle: 'Partner group settings',
    createFormTitle: 'Create partner group form',
    formFieldsBlockTitle: 'Main',
    formFieldsSecondBlockTitle: 'Group offers',
    formFieldsThirdBlockTitle: 'Group partners',
    managerListPlaceholder: 'Full name & email search',
    formFieldsFourthBlockTitle: 'Group managers',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Partner groups',
    table: {
      id: 'ID',
      title: 'Title',
      leaders: 'Team leaders',
      offers: 'Offers',
      partners: 'Partners',
      managers: 'Managers',
      status: 'Status',
      actions: 'Actions',
      miraCRMDepartmentId: 'Mira CRM department ID',
      searchPlaceholder: 'Title, Mira ID search',
    },
    field: {
      title: 'Title*',
      leaders: 'Team leaders',
      active: 'Status',
      teamLeaderForCostReport: 'Team leader for Costs report',
      titleForPartnerUser: 'Title for partner user',
      type: 'Type',
      miraCRMDepartmentId: 'Mira CRM department ID',
      showOfferPartnerCategory: 'Show Offer-Partner category',
      showOfferPartnerCategoryHint:
        'Show the Offer category selector for Offer-Partners of this group and the Offer category filter and grouping in General report, Cohort analysis and Budget planner.',
    },
  },

  dashboard: {
    listTitle: 'Dashboard',
    menuItemName: 'Dashboard',
    efficiencyChartTitle: 'Efficiency chart',
    efficiencyChartSubtitle: 'Time-series of new depositors, deposit counts, income, and ROI for the selected period.',
    efficiencyChartExportTitle: 'Efficiency_chart',
    chart: {
      title: 'Title',
      newDep: 'New dep',
      amountOfNew: 'First day amount of dep',
      amountOfAll: 'Amount of all deps',
      income: 'Income',
      roi: 'ROI',
      spend: 'Spend',
      svg: 'Download SVG',
      png: 'Download PNG',
      csv: 'Download CSV',
    },
    topPartners: {
      title: 'Top 5 partners',
      subtitle: 'Sorted by highest New dep count.',
    },
    topCountries: {
      title: 'Top 5 countries',
      subtitle: 'Sorted by highest New dep count.',
    },
    chartPeriods: {
      day: 'Day',
      week: 'Week',
      month: 'Month',
    },
  },
  generalReport: {
    listTitle: 'General report',
    listSubtitle:
      'Core metrics on clicks and player activity: registrations, deposits, bets, and spend. Optimized for long-range queries using the ClickHouse engine.',
    listSubtitleClick: 'Core metrics on clicks and player activity: registrations, deposits, bets, and spend.',
    generateGR: 'Build General report',
    editFormTitle: 'Update',
    createFormTitle: 'Create',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'General report',
    menuItemNameOld: 'General report (old)',
    datePeriod: 'Data period',
    exportDisabled: 'Generate the report first to enable export.',
    openCohortAnalysis: 'Cohort analysis',
    openCohortAnalysisTooltip: 'Opens Cohort analysis with the currently selected filters',
    rowsQty: 'First group rows quantity – ',
    differentCommissions: 'Different commissions',
    table: {
      advertiser: 'Advertiser',
      partner: 'Partner',
      category: 'Category',
      partnerGroup: 'Partner group',
      partner_tag: 'Partner tag',
      partnerTags: 'Partner |tags',
      offerTags: 'Offer |tags',
      product: 'Product',
      country: 'Country',
      offer: 'Offer',
      siteId: 'Site ID',
      month: 'Month',
      promocode: 'Promocode',
      geo_country: 'Actual country',
      subId: 'Sub ID',
      site_id_sub_id: 'Site ID & Sub ID',
      site_id: 'Site ID',
      sub_id: 'Sub ID',
      sub_1: 'Sub ID 1',
      sub_2: 'Sub ID 2',
      sub_3: 'Sub ID 3',
      sub_4: 'Sub ID 4',
      sub_5: 'Sub ID 5',
      sub_6: 'Sub ID 6',
      sub_7: 'Sub ID 7',
      sub_8: 'Sub ID 8',
      sub_9: 'Sub ID 9',
      segment: 'Segment',
      noSegment: 'No segment',
      player_id: 'Player ID',
      clickId: 'Click ID',
      playerId: 'Player ID',
      landing: 'Landing',
      stream: 'Stream',
      affiliateId: 'Affiliate ID',
      affiliate_id: 'Affiliate ID',
      affiliateIdTag: 'Affiliate ID tag',
      week: 'Week',
      manager: 'Manager',
      paymentModel: 'Payment |model',
      payment_model: 'Payment |model',
      offerCategory: 'Offer |category',
      offer_category: 'Offer |category',
      notUsedSpend: 'Spend without traffic',
      landingNotSelected: '<Landing not selected>',
      click_idNotSelected: '',
      traffic: 'Traffic |source',
      trafficNotSelected: '<Traffic source not selected>',
      notSelected: 'Not selected',
      date: 'Period',
      actualCountry: 'Actual |country',
      registrations: 'New |regs',
      newDeposits: 'New |deps',
      regDep: 'Reg/Dep',
      deposits: 'Amount of |all deps',
      bets: 'Amount of |all bets',
      all_deposits: 'All |deps',
      allDepositsTooltip:
        'Each deposit entry corresponds to a unique day on which the user made a deposit. The system does not retain data on multiple deposits made by the user within the same day.',
      amount_newDeposits: ' First day |amount of dep',
      firstDepAmount: 'First dep |amount',
      amount_bets: 'Amount |of bets',
      avg_bet: 'Average |bet',
      avg_check: 'Average |check',
      avg_new_check: 'Average |new check',
      income: 'Income',
      spend: 'Spend',
      spendPercent: 'Spend |percent',
      bonus: 'Bonus',
      cpaSpend: 'CPA |spend',
      rsSpend: 'RS',
      totalSpend: 'Total |spend',
      epc: 'EPC',
      epcTooltip: 'Total spend/Clicks',
      cfd: 'cFD',
      roi: 'ROI',
      dss: 'DepSum/|Spend',
      bss: 'BetSum/|Spend',
      click_count: 'Clicks',
      unique_click_count: 'Unique',
      click_reg: 'Click/Reg',
      actions: 'Actions',
    },
    field: {
      name: 'Name*',
      placeholder: 'Sum*',
      active: 'Status',
    },
    groupBy: {
      offer: 'Offer',
      partner: 'Partner',
      partnerTag: 'Partner tag',
      advertiser: 'Advertiser',
      clickId: 'Player ID',
      siteId: 'Site ID',
      subId: 'Sub ID',
      siteIdSubId: 'Site ID & Sub ID',
      affiliateId: 'Affiliate ID',
      date: 'Day',
      week: 'Week',
      country: 'Country',
      product: 'Product',
      landing: 'Landing',
      month: 'Month',
      promocode: 'Promocode',
      traffic: 'Traffic source',
      stream: 'Stream',
      paymentModel: 'Payment model',
      offerCategory: 'Offer category',
      actualCountry: 'Actual country',
      manager: 'Manager',
      partner_group: 'Partner group',
      off: 'Off',
      sub1: 'Sub ID 1',
      sub2: 'Sub ID 2',
      sub3: 'Sub ID 3',
      sub4: 'Sub ID 4',
      sub5: 'Sub ID 5',
      sub6: 'Sub ID 6',
      sub7: 'Sub ID 7',
      sub8: 'Sub ID 8',
      sub9: 'Sub ID 9',
      segment: 'Segment',
    },
    select: {
      all: 'All',
      firstDep: 'FTD only',
      deposit: 'Deposits only',
      registration: 'Registrations only',
      new_players: 'New players',
      new_player_reg: 'New players by reg date',
    },
    baseline: {
      qualified: 'Qualified',
      unqualified: 'Unqualified',
      all: 'All',
    },
    spend: {
      default: 'Default',
      onlyWithSpend: 'Only with spend',
    },
  },

  cpaRsPerformanceReport: {
    listTitle: 'CPA+RS performance report',
    listSubtitle:
      'Analyze partner performance and financial results for traffic using the combined CPA+RS & RevShare payment models.',
    listSubtitleClick:
      'Analyze partner performance and financial results for traffic using the combined CPA+RS & RevShare payment models.',
    menuItemName: 'CPA+RS performance report',
  },

  playersReports: {
    formFieldsBlockTitle: 'General data',
    formFieldsBlockSecondTitle: 'Players data',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    mainItemName: 'Reports',
    deleteReport: 'Delete the report',

    importSettings: 'Import settings',
    shouldUpdate: 'Update registration dates for existing players?',
    modalRequestSent:
      'Your request was submitted successfully and is now being processed. This typically takes 30 seconds to a few minutes.',
    table: {
      id: 'ID',
      createDate: 'Created date & time, UTC',
      uploadDate: 'Updated date & time, UTC',
      request: 'Requested Site IDs',
      response: 'Original response',
      registrationDate: 'Registration date',
      firstDepositDate: 'First deposit date',
      period: 'Report date',
      warnings: 'Warnings',
      warningsLog: 'Warnings log file',
      actions: 'Actions',
    },
    field: {
      name: 'Name*',
      placeholder: 'Sum*',
      active: 'Status',
    },
    uploadPlayersInfo: 'The report contains Click IDs that are not present in the DB. Download ',
  },

  players: {
    listTitle: 'Players',
    editFormTitle: 'Player',
    createFormTitle: 'Create player form',
    formFieldsBlockTitle: 'Main',
    formFieldsBlockSecondTitle: 'Payment status',
    playerPaymentStatus: 'Player payment status',
    formFieldsBlockThirdTitle: 'Player postbacks',
    formFieldsBlockFourthTitle: 'Player reports',
    qualificationStatus: 'Qualification status',
    qualificationDate: 'Qualification date',
    qualifiedOn: 'on {date}',
    offerPartnerId: 'Offer-Partner ID',
    cost: 'Cost',
    paymentModel: 'Payment model',
    notRequired: 'Not required',
    qualificationTable: {
      condition: 'Condition',
      details: 'Details',
      playerData: 'Player data',
      status: 'Status',
    },
    paymentResolution: 'Payment resolution',
    paymentResolutionApproved: 'Approved',
    notCpaModel: 'The player is not assigned to CPA or CPA+RS payment models.',
    resetPaymentResolution: 'Reset payment resolution',
    paymentResolutionNotApproved: 'Not approved',
    datePickerLabel: 'Created date (UTC)',
    saveSuccess: 'Player(s) successfully updated',
    tableDescription: "This section displays the player's financial data retrieved from the API service",
    filterByReportDate: 'Filter by report date',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Players',
    importFile: 'Import report',
    table: {
      id: 'Player inner ID',
      outerId: 'Player ID',
      clickId: 'Click ID',
      innerClickId: 'Inner click ID',
      createdAt: 'Created, UTC',
      registrationDate: 'Registration, UTC',
      actualCountry: 'Actual country',
      siteId: 'Site ID',
      promocode: 'Promocode',
      subId: 'Extended Sub ID',
      oplSubId: 'Offer-Partner-Landing Sub ID',
      segment: 'Segment',
      landing: 'Landing',
      trafficSource: 'Traffic source',
      source: 'Traffic source',
      partner: 'Partner',
      stream: 'Stream',
      advertiser: 'Advertiser',
      country: 'Country',
      mediaId: 'Country & Media ID',
      geoCountry: 'IP',
      offer: 'Offer',
      offerPartnerUUID: 'Offer-Partner-Landing UUID',
      firstDepositDate: 'First deposit, UTC',
      firstDeposit: 'First deposit, UTC',
      qualified: 'Qualified',
      partnerLink: 'Partner link',
      advLink: 'Advertiser link',
      userAgent: 'UA',
      referrer: 'Referrer',
    },
    tablePostback: {
      id: 'ID',
      date: 'Date & time, UTC+6',
      eventType: 'Event type',
      eventValue: 'Event value',
      senderIp: 'Sender IP',
      url: 'URL',
      partnerPostbackUrl: 'Partner postback URL',
      partnerPostbackMethod: 'Partner postback method',
      partnerPostbackDate: 'Sent to partner, UTC',
      transactionId: 'Track ID',
      response: 'Response',
      error: 'Error',
    },
    tableReports: {
      createdAt: 'Created date & time, UTC',
      updatedAt: 'Updated date & time, UTC',
      reportDate: 'Report date',
      newDep: ' First day amount of dep',
      reportData: 'Report data',
      newDepTooltip: 'Value of "ftd_sum" from Players Report',
      deposits: 'Amount of deposits (total {sum})',
      depositsNoSum: 'Amount of deposits |(total {sum})',
      newDepositsNoSum: ' First day amount of dep |(total {sum})',
      newDepositsNoSumTooltip: 'Value of "ftd_date" from Players Report',
      bets: 'Amount of bets (total {sum})',
      betsNoSum: 'Amount of bets |(total {sum})',
      betsTooltip: 'Value of "income" from Players report',
      bonusNoSum: 'Bonus |(total {sum})',
      commissionNoSum: 'Commission |(total {sum})',
      totalCommissionNoSum: 'Total commission |(total {sum})',
      income: 'Company income (total {sum})',
      incomeTooltip: 'Value of "net_rev" from Players report',
      incomeNoSum: 'Income |(total {sum})',
      firstDepositDateTooltip: 'Value of the first "date" from the player report',
      subIdTooltip:
        "The real player's Sub ID, containing the original Offer-Partner-Landing Sub ID and the Sub IDs from the original partner link.",
    },
    field: {
      name: 'Name*',
      placeholder: 'Sum*',
      active: 'Status',
    },
    sourceApi: '<source: API>',
  },

  currencies: {
    listTitle: 'Currencies',
    editFormTitle: 'Currency settings',
    createFormTitle: 'Create currency form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Currencies',
    table: {
      id: 'ID',
      title: 'Title',
      value: 'Value in tag',
      active: 'Status',
      actions: 'Actions',
      searchPlaceholder: 'Title search',
    },
    field: {
      title: 'Title*',
      value: 'Value in tag (adv. link)',
      active: 'Status',
    },
  },

  postbacks: {
    listTitle: 'Postbacks',
    editFormTitle: 'Update postback',
    createFormTitle: 'Create postback form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Postbacks',
    resendPostbacks: 'Resend postbacks',
    resendPostback: 'Resend postback',
    datePickerLabel: 'Received date (UTC+6)',
    table: {
      id: 'ID',
      createdAt: 'Received, UTC+6',
      createdAtKyiv: 'Date & Time, Kyiv time',
      advertiser: 'Advertiser',
      clickId: 'Click ID',
      innerClickId: 'Inner click ID',
      playerId: 'Player ID',
      partnerId: 'Partner ID',
      siteId: 'Site ID',
      landing: 'Landing',
      sum: 'Sum dep',
      country: 'Country',
      geoCountry: 'Actual country',
      transaction: 'Transaction',
      other: 'Other',
      offer: 'Offer',
      partner: 'Partner',
      trafficSource: 'Traffic source',
      eventType: 'Event Type',
      eventValue: 'Event Value',
      senderIp: 'Sender IP',
      uuid: 'Offer-Partner-Landing UUID',
      url: 'URL',
      postbackPartner: 'Partner',
      partnerPostbackUrl: 'Partner postback URL',
      partnerPostbackMethod: 'Partner postback method',
      partnerPostbackDate: 'Sent to partner, UTC',
      transactionId: 'Track ID',
      response: 'Response',
      error: 'Error',
      actions: 'Actions',
    },
    field: {
      name: 'Name*',
      placeholder: 'Sum*',
      active: 'Status',
    },
  },

  events: {
    listTitle: 'Events',
    editFormTitle: 'Event settings',
    createFormTitle: 'Create event form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Events',
    table: {
      id: 'ID',
      name: 'Title',
      partner: 'Partner',
      placeholder: 'Parameter name',
      searchPlaceholder: 'Title, Parameter name search',
      active: 'Status',
      actions: 'Actions',
    },
    field: {
      name: 'Name*',
      placeholder: 'Parameter name',
      active: 'Status',
    },
  },

  partnersSpends: {
    permissionTitle: 'Partners spend',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    importSuccess: 'File successfully uploaded',
    menuItemName: 'Partners spend',
    table: {
      name: 'Name',
      sum: 'Sum (total {sum})',
      sumNoTotal: 'Sum',
    },
  },

  users: {
    listTitle: 'Users',
    editFormTitle: 'User profile',
    createFormTitle: 'User сreate form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    searchPlaceholder: 'Full name, Email, Mira ID search',
    menuItemName: 'Users',
    table: {
      id: 'ID',
      name: 'Full name',
      email: 'Email',
      role: 'Role',
      partners: 'Partners',
      miraCRMUserId: 'Mira CRM User ID',
      soloCRMUserId: 'Solo CRM User ID',
      createdAt: 'Created, UTC',
      enabled: 'Status',
      actions: 'Actions',
    },
    field: {
      name: 'Full name',
      email: 'Email*',
      password: 'Password*',
      enabled: 'Status',
      role: 'Role',
      nameForCostReport: 'Name for analysts',
      miraCRMUserId: 'Mira CRM User ID',
      soloCRMUserId: 'Solo CRM User ID',
      currentPassword: 'Current password',
      newPassword: 'New password',
      enterCurrentPassword: 'Enter current password',
      enterNewPassword: 'Enter new password',
    },
    roles: {
      ADMIN: 'Admin',
      TEAM_LEADER: 'Team leader',
      MANAGER: 'Manager',
      PARTNER: 'Partner',
      AUDITOR: 'Auditor',
    },
    tabs: {
      main: 'Main data',
      password: 'Password',
      twoFactor: '2-fa Reset',
      sessions: 'Active sessions',
      loginLog: 'Login logs',
    },
    loginLog: {
      title: 'Login logs',
      noLogs: 'There are no login logs',
      noLogsData: 'This user has no recorded login activity yet.',
      unknownDevice: 'Unknown device',
      loginTime: 'Login date & time, UTC',
      userAgent: 'User agent',
      ip: 'IP',
      ipSubnet: 'IP subnet',
      asn: 'ASN',
      timezone: 'Timezone',
      languages: 'Accept-Language',
      fingerprint: 'Fingerprint:',
    },
    sessions: {
      title: 'Active sessions',
      logout: 'Log out',
      logoutConfirmTitle: 'Log out',
      logoutConfirmDesc: 'You are about to close this session. Are you sure you want to proceed?',
      logoutAllConfirmTitle: 'Log out of all sessions',
      logoutAllConfirmDesc:
        'Are you sure you want to log out of all active sessions on this account? All sessions will be disconnected immediately.',
      noSessions: 'There are no active sessions',
      noSessionsData: 'This user is not currently signed in on any devices.',
      loginTime: 'Token expiration date & time, UTC',
      validUntil: 'Valid until, UTC',
      userAgent: 'User agent',
      ip: 'IP',
      ipSubnet: 'IP subnet',
      asn: 'ASN',
      timezone: 'Timezone',
      languages: 'Accept-Language',
      current: 'Current',
      logoutAll: 'Log out from all sessions',
      logoutAllDesc: 'Close all active sessions.',
      unknownDevice: 'Unknown device',
    },
    loginAs: 'Log in as this user',
    loginAsDesc: 'Log in to this user account.',
    loginAsConfirmTitle: 'Log in as this user',
    loginAsConfirmDesc: 'Are you sure you want to log in to the system as this user?',
    impersonatingAs: 'Viewing as:',
    exitImpersonation: 'Return to my account',
    reset2faConfirmTitle: 'Reset 2-FA',
    reset2faConfirmDesc: 'Are you sure you want to reset two-factor authentication for this user?',
    reset2fa: 'Reset 2FA',
    reset2faInfo: 'Two-factor authentication is always enabled on all accounts.',
    reset2faDesc:
      'Resetting 2FA will invalidate the current verification setup and require re-verification on the next sign-in.',
    successModalDesc:
      'We’ve generated a temporary login link and sent it to the user’s email address.The link is valid for 24 hours. If it expires, you can send a new one.',
    accountSetupLink: {
      title: 'Account setup',
      desc: 'The setup link is sent to the user to complete account creation and set a password. It expires after 24 hours for security reasons. If the link is no longer valid, the user will need to request a new one from the administrator.',
      resendLink: 'Resend link',
      resendSuccess: 'Link resent successfully.',
    },
    successModalTitle: 'User created',
  },

  clicks: {
    listTitle: 'Clicks',
    editFormTitle: 'CRUD Edit Heading',
    createFormTitle: 'CRUD Create Heading',
    formFieldsBlockTitle: 'Fields for data',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    search: 'Click ID search',
    menuItemName: 'Clicks',
    uniqueness: 'Uniqueness',
    unique: 'Unique',
    duplicate: 'Duplicate',
    datePickerLabel: 'Received date (UTC)',
    table: {
      id: 'Inner click ID',
      clickId: 'Click ID',
      segment: 'Segment',
      createdAt: 'Received, UTC',
      offerTitle: 'Offer',
      partnerTitle: 'Partner',
      advertiserTitle: 'Advertiser',
      landing: 'Landing',
      stream: 'Stream',
      siteId: 'Site ID',
      partnerLink: 'Partner link',
      advertiserLink: 'Advertiser link',
      canonicalId: 'Canonical ID',
      canonicalIdTooltip: 'Represents the ID of the original click. The field remains empty if the click is unique.',
      offerPartnerLandingUuid: 'Offer-Partner-Landing UUID',
      country: 'Country',
      actions: 'Actions',
      IP: 'IP',
      userAgent: 'UA',
      traffic: 'Traffic source',
      referrer: 'Referrer',
    },
    field: {
      idOneC: 'ID 1c',
      name: 'Name',
      countries: 'Countries',
      countries2: 'Countries 2',
      scriptName: 'Name for scripts',
    },
  },

  partners: {
    listTitle: 'Partners',
    editFormTitle: 'Partner settings',
    createFormTitle: 'Create partner form',
    formFieldsBlockTitle: 'Main partner data',
    formFieldsManagersBlockTitle: 'Managers',
    formFieldsManagersBlockSubtitle: 'Managers associated with current partner.',
    formFieldsUsersBlockTitle: 'Partner users',
    formFieldsUsersBlockSubtitle: 'Users with the Partner role who work with the current partner.',
    formFieldsStreamBlockTitle: 'Streams',
    formFieldsStreamBlockSubtitle: 'Streams and their associations with partner’s groups.',
    formFieldsAffiliateBlockTitle: 'Affiliate IDs',
    formFieldsAffiliateBlockSubtitle: 'Specific partner affiliate IDs for each advertisers.',
    formRiskLevelTitle: 'Risk level',
    formRiskLevelSubtitle:
      'Below are the current potential connections to other partner accounts that may be operated by the same team, as of now.',
    partnerGroupsResources: 'Partner groups & Spend resources',
    partnerGroupsResourcesDesc: 'Partner groups associated with current partner and spend import setup.',
    partnerMainInfo: 'Main data',
    partnerInfo: 'Additional partner data',
    formFieldsFirstBlockTitle: 'Postback URLs',
    formFieldsFirstBlockSubtitle: 'Postback URLs where event postbacks from advertisers should be sent by the system.',
    groupRequired: 'To add managers, you must add at least 1 group above',
    formTwoFieldsBlockTitle: 'Offer–Partner list',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    postbackTitle: '{title} postback',
    menuItemName: 'Partners',
    disabledParse: 'Save changes to parse spend',
    customLanding: 'Add custom landing',
    recommendLanding: 'Add default landing(s)',
    periodExpired: 'This period has ended, and there is no active period for the current date.',
    modal: {
      parseManually: 'Parse manually',
      period: 'Period',
      date: 'Date',
      day: 'Day',
      month: 'Month',
      parseManuallyDescription:
        'Your request was submitted successfully and is now being processed. ' +
        'This typically takes 30 seconds to a few minutes. Once complete, an entry will appear in the parsing logs.',
    },
    table: {
      id: 'ID',
      title: 'Title',
      offerPartners: 'Offers',
      users: 'Partner users',
      category: 'Category',
      active: 'Status',
      actions: 'Actions',
      searchPlaceholder: 'Title, Site ID & Affiliate ID search',
    },
    field: {
      title: 'Title*',
      status: 'Status',
      state: 'State',
      paymentDetails: 'Payment details',
      partnerUsers: 'Partner users',
      partnerUser: 'Partner user',
      partnerGroups: 'Partner groups',
      partnerGroup: 'Partner group',
      spendImportMethod: 'Spend import method',
      clickIdUsage: 'Click id usage',
      clickIdUsageTooltip:
        "When the inner click ID option is selected, the advertiser receives the inner click ID instead of the partner's Click ID. Partner postbacks continue to contain the partner's click ID.",
      sendInnerClickId: 'Send inner click ID to advertiser',
      sendPartnerClickId: 'Send partner click ID to advertiser',
      pandaApi: 'RTB Panda API',
      kadamApi: 'Kadam API',
      trafficStars: 'Traffic stars',
      exoclick: 'Exoclick',
      spreadsheet: 'Parsing from sheet',
      offer: 'Offer*',
      siteId: 'Site ID',
      siteIdRequired: 'Site ID*',
      apiTokenRequired: 'Token*',
      hasDuplicate: 'This Site ID already exists',
      countryRequirements: 'Country matching requirement for qualification',
      hasDuplicateNotification:
        'The stream with Site ID {siteId} already exists in the partner {partner}. The system does not allow duplicate entries.',
      subId: 'Sub ID',
      user: 'User logins',
      telegram: 'Telegram contacts',
      offerTags: 'Offer tags',
      email: 'Emails',
      partnerTags: 'Partner tags',
      postback: 'Postback',
      currency: 'Currency',
      currencyRequired: 'Currency*',
      paymentSystem: 'Payment system',
      address: 'Address',
      postbackNum: 'Postback {num}',
      postbackUUID: 'Postback UUID',
      postbackUUIDRequired: 'Postback UUID*',
      landing: 'Landing',
      partnerLink: 'Partner link',
      advertiserLink: 'Advertiser Link',
      postbackUrl: 'Postback URL',
      stream: 'Stream',
      streamRequired: 'Stream*',
      method: 'Method',
      siteName: 'Site name',
      manager: 'Manager',
      linkOffer: 'Link Offer',
      promoCodes: 'Promo Codes',
      baseline: 'Baseline',
      baselinePeriod: 'Baseline period, days',
      maxDaysFromRegistration: 'Max days from registration',
      betRequirement: 'Bet requirement for qualification',
      subIdPlaceholder: 'Sub ID placeholder',
      sendSubId: 'Resend sub_(s) from Partner links',
      sendSubIdPlaceholder: 'Placeholder of the sub_id parameter in the Partner link',
      sheetId: 'Spend’s sheet id',
      apiToken: 'Token',
      affiliateId: 'Affiliate ID',
      affiliateIdTag: 'Affiliate ID tag',
      affiliateIdDuplicate: 'This Affiliate ID is already added for this advertiser.',
      affiliateIdDuplicateExisting: 'This Affiliate ID for this advertiser is already used by another partner.',
      teamName: 'Team name',
    },
    mediaIdMissing: 'Media ID or advertiser domain is missing. The system cannot create the link.',
    unapproved: 'The link can not be created because the partner is not approved',
    buttons: {
      logs: 'View logs',
      parseMan: 'Parse now',
      parseApi: 'Import now',
      duplicatesExport: 'Export duplicates',
    },
    position: {
      main: 'Main',
      ordinary: 'Ordinary',
    },
    riskLevel: {
      users: 'Matched partner users',
      matchedData: 'Matched data',
      score: 'Score',
      tooltip:
        'Risk level reflects cases where the same group of people may act under multiple partner accounts using different user profiles, while sharing similar technical signals. The overall risk level is calculated once per day for the past 90-day period.',
      overallRiskLevel: 'Overall risk level',
      riskLevel: 'Risk level',
      noResults: 'No risk indicators were identified. All checks passed successfully.',
      riskLevelTooltip:
        'Risk level reflects cases where the same group of people may act under multiple partner accounts using different user profiles, while sharing similar technical signals.',
      date: 'Date & time, UTC',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      noRisk: 'No risk',
      ip_subnet: 'IP subnet',
      partner_finger_print_hash: 'Partner fingerprint hash',
      asn: 'ASN',
    },
    countryReplacementRules: {
      title: 'Country replacement rules',
      subtitle:
        'Rules to replace the spend country of a specific partner stream with another country during spend import/parsing.',
      addRule: 'Add rule',
      noResults: 'No rules added yet.',
      errorCountriesMustDiffer: 'Original country and new country must differ.',
      field: {
        originalCountry: 'Original country*',
        newCountry: 'New country*',
      },
    },
    category: {
      tooltip:
        'The category is based on the spend during the full previous month across all payment models. Reports show up-to-date data, while the category in the Partners list and Partner details is updated daily at 14:00 UTC.',
      assignmentTitle: 'Category assignment',
      group: 'Group',
      assignedCategory: 'Assigned category',
      notCategorized: 'Not categorized',
    },
  },

  requestMethods: {
    get: 'GET',
    post: 'POST',
  },

  offer: {
    noLandings: 'No default landing(s) to add',
    listTitle: 'Offers',
    editFormTitle: 'Offer settings',
    createFormTitle: 'Create offer form',
    formFieldsBlockTitle: 'Main offer data',
    formTwoFieldsBlockTitle: 'Offer–Partner list',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    invalidFields: 'Empty required fields in "{tab}" tab',
    paymentModelChanged:
      'Please note that changing the payment model will not delete the agent spend from the database. You will need to remove it manually.',
    menuItemName: 'Offers',
    table: {
      id: 'ID',
      title: 'Title',
      advertiserTitle: 'Advertiser',
      countryTitle: 'Country',
      paymentModelTitle: 'Payment model',
      currency: 'Currency',
      cost: 'Cost',
      productTitle: 'Product',
      status: 'Status',
      state: 'State',
      groups: 'Groups',
      searchPlaceholder: 'Title search',
      actions: 'Actions',
    },
    field: {
      title: 'Title*',
      advertiser: 'Advertiser',
      country: 'Country',
      paymentModel: 'Payment model',
      cost: 'Cost',
      days: 'Days',
      baseline: 'Baseline',
      stream: 'Stream',
      streamRequired: 'Stream*',
      currency: 'Currency',
      currencyRequired: 'Currency*',
      source: 'Traffic source',
      product: 'Product',
      partner: 'Partner*',
      siteId: 'Site ID',
      subId: 'Sub ID',
      bet: 'Bet',
      mainPostback: 'Main postback',
      extraPostback: 'Extra postback',
      landing: 'Landing',
      linkLanding: 'Link landing',
      landings: 'Offer–Partner landings and their links',
      partnerLink: 'Partner link',
      partnerLinks: 'Partner links',
      advertiserLink: 'Advertiser link: {link}',
      differentLink: 'This link does not match the link in the database. The link in the database: {link}',
      linkPartner: 'Link partner',
      linkOffer: 'Link offer',
      status: 'Status',
      state: 'State',
      generalInfo: 'Create offer–partner form',
      offerPartnerId: 'Offer–Partner {id}',
      offerPartnerFilters: 'Offer–Partner filters',
    },
    states: {
      approved: 'Approved',
      unapproved: 'Unapproved',
    },
    offerCategory: {
      label: 'Offer category',
      testing: 'Testing',
      regular: 'Regular',
      system: 'System',
      hint: '{category} since {date}, set by {author}.',
      newHint: 'A new Offer-Partner starts as Testing. The category can be changed after saving.',
      hintRule:
        "Regular is assigned automatically once the Offer-Partner's spend reaches 3,000 within the last 30 days, counted from that date. The category is never downgraded automatically.",
    },
    showLess: 'Show less',
    showMore: 'Show more',
    expandAll: 'Expand offer-partners',
    deleteOfferPartner: 'Delete this Offer - Partner',
    hideAll: 'Roll up offer-partners',
    cpaSettings: 'CPA settings',
    multigeoSettings: 'Multigeo CPA settings',
    multigeoCountryRequired: 'Select country for all multigeo rows',
    multigeoSpendRevshareNotAllowed: 'Spend and RevShare payment models are not allowed for Multigeo country',
    costHistory: 'Cost and Baseline history',
    costHistoryDesc:
      'This section allows configuration of the cost, baseline values, and their activity periods for the current offer-partner.',
    blPeriodHistory: 'Baseline period history',
    blPeriodHistoryDesc:
      'This section allows configuration of how many days after the first deposit players associated with the current offer-partner have to meet the baseline.',
    blDepositHistory: 'Bet requirement for qualification history',
    blDepositHistoryDesc:
      'This section sets the date range in which players of the offer-partner must place a minimal bet during the Baseline and Max registration periods to meet the conditions and qualify.',
    daysRegistrationHistory: '“Max days from registration” history',
    daysRegistrationHistoryDesc:
      'This section allows configuration of the number of days after registration that players associated with the current offer-partner have to meet baseline conditions.',
    countryRequirements: 'Country matching requirement for qualification',
    countryRequirementsDesc: 'Country matching requirement for qualification',
    intersection: 'Data interception issue. Please check ranges above.',
    addCost: 'Add cost',
    add: 'Add',
    unapproved: 'The link can not be created because the offer is not approved',
  },

  country: {
    listTitle: 'Countries',
    editFormTitle: 'Country settings',
    createFormTitle: 'Create country form',
    formFieldsBlockTitle: 'Main',
    formFieldsSecondBlockTitle: 'Alternative titles',
    formFieldsSecondBlockDesc:
      'Different country title variations are used to match the player’s actual country when receiving data from the 3rd-party API service.',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Countries',
    active: 'Active',
    inactive: 'Inactive',
    activity: 'Status',
    table: {
      id: 'ID',
      title: 'Title',
      slug: 'Code',
      subId: 'Sub ID',
      currency: 'Currency',
      domain: 'Default partner link domain',
      miraCRMCountryId: 'Mira CRM Country ID',
      active: 'Status',
      actions: 'Actions',
      searchPlaceholder: 'Title, Code, Mira ID search',
    },
    field: {
      title: 'Title*',
      slug: 'Code',
      subId: 'Sub ID',
      currency: 'Currency',
      miraCRMCountryId: 'Mira CRM Country ID',
      domain: 'Default partner link domain',
      domainTooltip:
        'Specific partner domains are defined per traffic type and country in the advertiser settings. If no match is found there, the system uses the default partner link domain selected here.',
      status: 'Status',
      titleBtn: 'Title',
    },
  },

  paymentModels: {
    listTitle: 'Payment models',
    editFormTitle: 'Payment model settings',
    createFormTitle: 'Create payment model form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Payment models',
    table: {
      id: 'ID',
      title: 'Title',
      cost: 'Cost',
      searchPlaceholder: 'Title search',
      active: 'Status',
      actions: 'Actions',
    },
    field: {
      title: 'Title*',
      costReportTitle: 'Title for analysts',
      cost: 'Cost',
      defaultCost: 'Default cost',
      defaultBaseline: 'Default baseline',
      defaultPeriod: 'Default baseline period (days)',
      maxDaysFromRegistration: 'Default max days from registration',
      defaultBetRequirement: 'Default bet requirement for qualification',
      defaultCountryMatching: 'Default country matching requirement for qualification',
      status: 'Status',
    },
  },
  advertisers: {
    listTitle: 'Advertisers',
    editFormTitle: 'Advertiser settings',
    createFormTitle: 'Create advertiser form',
    formFieldsBlockTitle: 'Main advertiser data',
    formFieldBlockCountries: 'Countries & Advertiser domains',
    formFieldBlockCountriesDesc:
      "Advertiser's countries and their settings for Offer-Partner-Landings and advertiser links.",
    formFieldBlockLandings: 'Default landings',
    formFieldBlockLandingsDesc: 'Landings that can be quickly added to an offer-partner of current advertiser.',
    formFieldBlockPartnerDomains: 'Partner domains',
    formFieldBlockPartnerDomainsDesc:
      'Partner domains defines domain mapping for partner links based on traffic type and country. If no match is found, the system uses the default partner link domain defined in the country settings.',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Advertisers',
    tooltipOfferExist:
      'The connection cannot be deleted because this country is linked to the following offers: {offers}',
    table: {
      id: 'ID',
      title: 'Title',
      domain: 'Default domain',
      miraCRMId: 'Mira CRM ID',
      defaultMiraCRMProjectId: 'Default Mira CRM Project ID',
      searchPlaceholder: 'Title, Domain, Mira ID search',
      active: 'Status',
      actions: 'Actions',
    },
    field: {
      title: 'Title*',
      country: 'Country*',
      defaultCurrency: 'Default currency',
      miraCRMId: 'Mira CRM ID',
      domain: 'Default domain (Start with https://)',
      defaultMiraCRMProjectId: 'Default Mira CRM Project ID',
      countryMiraCRMProjectId: 'Country specific Mira CRM Project ID',
      status: 'Status',
      mediaId: 'Media ID',
      specificDomain: 'Country specific advertiser domain (Start with https://)',
      costBaseline: 'Default cost',
      defaultBaseline: 'Default baseline',
      allowedLandings: 'Allowed landings',
      linkCountry: 'Country',
      addLanding: 'Landing',
      trafficSourceType: 'Traffic source type',
      partnerLinkDomain: 'Partner link domain',
    },
    modal: {
      requestSent:
        'Your request was submitted successfully and is now being processed. This typically takes 30 seconds to a few minutes.',
    },
  },
  modalSuccessError: {
    close: 'Close',
    success: 'Success',
    error: 'Error',
    successSync: 'Sync completed successfully',
    errorSync: 'Error during sync',
  },
  products: {
    listTitle: 'Products',
    editFormTitle: 'Product settings',
    createFormTitle: 'Create product form',
    formFieldsBlockTitle: 'Main',
    formCreateUpdateSubmitErrorMessage: 'Request error',
    menuItemName: 'Products',
    table: {
      id: 'ID',
      title: 'Title',
      active: 'Status',
      searchPlaceholder: 'Title, ID search',
      actions: 'Actions',
    },
    field: {
      title: 'Title*',
      status: 'Status',
    },
  },

  filters: {
    id: 'ID',
    creator: 'Creator',
    activity: 'Status',
    activityType: 'Activity type',
    partner: 'Partner',
    partners: 'Partners',
    advertiser: 'Advertiser',
    advertiserRequired: 'Advertiser*',
    country: 'Country',
    countries: 'Countries',
    offer: 'Offer',
    roles: 'Roles',
    paymentModel: 'Payment model',
    partnerTags: 'Partner tags',
    offerCategory: 'Offer category',
    partnerTag: 'Partner tag',
    offerTags: 'Offer tags',
    offerTag: 'Offer tag',
    pModel: 'Payment model',
    postback: 'Postback',
    mainPostback: 'Main postback',
    extraPostback: 'Extra postback',
    subId: 'Sub ID',
    segment: 'Segment',
    siteId: 'Site ID',
    siteIdSearch: 'Site ID search',
    mediaId: 'Media ID',
    clickId: 'Click ID',
    innerClickId: 'Inner click ID',
    product: 'Product',
    products: 'Products',
    productReq: 'Product*',
    productsReq: 'Products*',
    players: 'Players',
    show: 'Show',
    manager: 'Manager',
    partnerGroup: 'Partner group',
    partnerUser: 'Partner user',
    partnerGroups: 'Partner group',
    partnerGroupsRequired: 'Partner groups*',
    landing: 'Landing',
    landings: 'Landings',
    landingReq: 'Landing*',
    landingsReq: 'Landings*',
    specificLandings: 'Specific landing',
    trafficSource: 'Traffic source',
    state: 'State',
    stream: 'Stream',
    baseline: 'Baseline',
    spend: 'Spend',
    geoCountry: 'Actual country',
    multigeoBreakdown: 'Multigeo breakdown',
    multigeoBreakdownOptions: {
      off: 'Off',
      actualCountry: 'By actual country',
    },
    multigeoBreakdownCountryHint: "For Multigeo offers — the player's actual country.",
    multigeoBreakdownHint:
      'A multi-geo offer covers many countries, so its data is normally reported in a single multi-geo row. "By actual country" splits it by the country each player actually came from and merges it with single-country offers for that country.',
    event: 'Event',
    user: 'User',
    promocode: 'Promocode',
    position: 'Position',
    createdDatePeriod: 'Created date',
    affiliateId: 'Affiliate ID',
    playerId: 'Player inner ID',
    playerOuterId: 'Player ID',
    transactionId: 'Track ID',
    canonicalId: 'Canonical ID',
    status: 'Status',
    approveFrom: 'Approve from',
    approveTo: 'Approve to',
    balanceFrom: 'Balance from',
    balanceTo: 'Balance to',
    factFrom: 'Fact from',
    factTo: 'Fact to',
  },

  settings: {
    settingsTitle: 'System settings',
    settingsGeneral: 'Main',
    dataFilter: 'Data filter',
    spendsParsing: 'Spend import setup',
    dailyParsingTime: 'Spend daily import from Sheets and APIs, UTC',
    monthlyParsingTime: 'Spend monthly import from Sheets, UTC',
    monthlyParsingDay: 'Spend monthly import from Sheets, day',
    dataSelect: 'Partner groups data view',
    dataRetrievalTime: 'Data retrieval time, UTC',
    menuItemName: 'System settings',
    saveSuccess: 'Data successfully updated',
    copySuccess: 'Data copied to clipboard',
    linkCopySuccess: 'Link copied to clipboard',
    uploadSuccess: 'Data uploaded successfully!',
    postbackSuccess: 'Postback(s) resent successfully',
    field: {
      domainName: 'Partner link domain',
      postBackUrl: 'URL for postbacks',
      postBackUrlDesc:
        "These URLs are configured to receive postbacks from other platforms. They support HTTP GET requests with the following parameters: 'click_id' and event types such as 'reg', 'ftd', and 'bl'.",
      dataFilterDesc:
        'This section enables the admin to globally activate a data filter by Partner Group, restricting access to data based on the selected group. When a Partner Group is chosen, the admin will only see data related to that group.',
      spendsParsingDesc:
        'This section configures the time for retrieving agent spend data from Google Sheets and 3rd-party APIs.',
      playersReports: "Players' reports from API-service",
      playersReportsDesc:
        'This section configures the time to retrieve players data from the 3rd-party API service for the previous day.',
      spendPercentage: 'Default spend percentage setup',
      spendPercentageDesc:
        'This section configures the default spend percentage for partners operating under the agency payment model.',
      spendPercentageInput: 'Percentage',
    },
    btn: {
      save: 'Save',
    },
  },
  base: {
    send: 'Send',
    preview: 'Preview',
    save: 'Save',
    saving: 'Saving',
    saved: 'Saved',
    copiedToClipboard: 'Copied to clipboard',
    submit: 'Submit',
    setup: 'Setup',
    generate: 'Generate',
    copy: 'Copy',
    max: 'Max',
    saveContinue: 'Save & continue',
    download: 'Download',
    cancel: 'Cancel',
    remove: 'Remove',
    delete: 'Delete',
    deleteRow: 'Delete row',
    create: 'Create',
    confirm: 'Confirm',
    showLink: 'Show link',
    duplicate: 'Duplicate',
    info: 'Info',
    system: 'System',
    areYouSureToDelete: 'Are you sure want to delete?',
    areYouSureToDeactivate: 'Confirm deactivation',
    areYouSureToActivate: 'Confirm activation',
    multiselectSelected: '{count} selected',
    yes: 'Yes',
    no: 'No',
    add: 'Add new',
    addRow: 'Add row',
    edit: 'Edit',
    editing: 'Editing',
    time: 'Time',
    back: 'Back',
    saveBack: 'Save & back',
    filters: 'Filters',
    apply: 'Apply',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    resetAll: 'Reset all',
    deactivate: 'Deactivate',
    activate: 'Activate',
    active: 'Active',
    inactive: 'Inactive',
    listStatusActive: 'Active',
    listStatusInactive: 'Inactive',
    search: 'Search',
    noData: 'No data',
    noMatchesFound: 'No matches found',
    all: 'All',
    allCount: 'All ({count})',
    onlyChosen: 'Only chosen',
    attention: 'Attention',
    fill: 'Fill',
    column: 'column',
    row: 'row',
    error: 'Error',
    validationError: 'Validation error',
    validationErrorServer: 'validation server error',
    unexpectedErrorOccurred: 'Unexpected error occurred. Please contact the development team.',
    somethingWentWrong: 'Something went wrong',
    noMoreItems: 'No more items',
    noElementsFound: 'No elements found',
    resetFilters: 'Reset',
    unsavedChanges: 'Unsaved changes',
    createdAt: 'Created at',
    createdBy: 'Created by',
    actions: 'Actions',
    city: 'City',
    district: 'District',
    region: 'Region',
    country: 'Country',
    today: 'Today',
    yesterday: 'Yesterday',
    currentMonth: 'Current month',
    noDataAvailable: 'No data available',
    startTypingText: 'Start typing text',
    change: 'Change',
    month: 'Month',
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    toTheBegining: 'To the beginning',
    warning: 'Warning',
    choosePeriod: 'Choose period',
    selectPeriod: 'Select period',
    rangeDays: 'Range days',
    filtersActive: 'Active',
    filtersDeactivated: 'Deactivated',
    filtersAll: 'All',
    selectFields: 'Select fields',
    open: 'Open',
    show: 'Show',
    close: 'Close',
    reset: 'Reset',
    operator: 'Operator',
    notOperator: 'Not operator',
    export: 'Export',
    exportReport: 'Export report',
    manualRequest: 'Manual request',
    apiAutoRequests: 'API auto requests current status:',
    images: 'Images',
    product: 'Product',
    selected: 'Selected',
    items: 'item | items',
    onPage: 'Showing',
    paginationOnPage: 'First group rows qty -',
    paginationFrom: 'from',
    history: 'History',
    field: 'Field',
    success: 'Success',
    comments: 'Comments',
    choose: 'Choose',
    value: 'Value',
    role: 'Role',
    group: 'Group',
    niche: 'Niche',
    total: 'Total',
    from: 'from',
    mobileView: 'For correct display use desktop version',
    goToMain: 'Go to main',
    returnToMainPage: 'Return to main page',
    showNumber: 'Show number',
    failedToLoad: 'Failed to load',
    failedToLoadDescription: 'Error while loading page. Try reload page',
    limitText: 'and {count} more',
    addSelectedOptions: 'Add selected options',
    removeSelectedOptions: 'Remove selected options',
    includeMode: 'Include mode',
    excludeMode: 'Exclude mode',
    ok: 'Хорошо',
    selectDate: 'Select date',
    presets: {
      today: 'Today',
      todayAndYesterday: 'Today and yesterday',
      last6Months: 'Last 6 months',
      last12Months: 'Last 12 months',
      yesterday: 'Yesterday',
      currentWeek: 'Current week',
      previousWeek: 'Previous week',
      currentMonth: 'Current month',
      previousMonth: 'Previous month',
      currentYear: 'Current year',
      previousYear: 'Previous year',
      todayPlus3Months: 'Today + 3 months',
      fromJanuary2021: 'From January, 2021',
    },
    beWaiting: 'Wait',
    dataLoading: 'The data is being processed',
    asidePlatformManagement: 'System management',
    asideUsersManagement: 'Users management',
    asideReports: 'Reports',
    requestSent: 'Request sent',
    requestSentDesc:
      'Your request has been successfully sent and is now being processed. This process typically takes about 8–12 minutes per 1 day.',
  },

  page: {
    login: 'Login',
    qrCode: 'Two-factor authentication settings',
    pageError403: 'Access forbidden',
    pageError404: 'Page not found',
    restore: 'Forgot password?',
    recoveryPassword: 'Recovery password',
    expiredToken: 'Expired Token',
  },
  tooltip: {
    settingsPage: 'Settings page',
    deleteEntity: 'Delete entity',
    activateEntity: 'Activate entity',
    deactivateEntity: 'Deactivate entity',
  },

  auth: {
    logout: 'Log out',
    logoutDesc: "You'll be logged out of your account.",
    expiredToken: 'Link expired',
  },

  authLogin: {
    username: 'Username',
    usernameExample: 'name@example.com',
    email: 'Email',
    password: 'Password',
    loginIn: 'Login',
    codeConfirm: 'Proceed',
    invalidCredentials: 'Wrong email or password!',
    invalidCode: 'Invalid or outdated code!',
    accessForbidden: 'Too many attempts',
    wrongData: 'Wrong email or password!',
    checkCredentials: 'Please check your credentials and try again.',
    forgetPassword: 'Forgot password?',
    welcome: 'Hey, hello ',
    welcomeDesc: 'Enter the information you entered while registering',
    twoFactorModalTitle: 'Two-factor authentication settings',
    twoFactorModalDesc: 'Enter 6-digit code from an authenticator app',
    twoFactorTitle: 'Two-factor authentication settings',
    twoFactorDescription: 'Scan the QR-code with an authenticator app. Enter 6-digit key from the app.',
    qrCode: 'Code from app',
    googleCode: 'Authenticator code',
    step: 'Step',
    step1SubTitle: 'Download the mobile app',
    step2SubTitle: 'Scan the QR code',
    step3SubTitle: 'Enter authentication code',
    step1SubDescription: 'Install an authenticator app (e.g., Google Authenticator) on your device',
    step2SubDescription: 'Open the app and scan the code with your camera',
    step3SubDescription: 'After scanning the QR code, enter the six-digit code generated by the application',
    errorComparePassword: 'Password does not meet the requirements',
    usedPassword: 'The password was used before',
    errorPassword: 'Invalid password',
    errorLogin: 'Invalid email',
  },
  authRestore: {
    email: 'Email',
    emailExample: 'name@example.com',
    forgetPassword: 'Forgot password?',
    authRestoreDesc: 'Enter your email and get a recovery link:',
    send: 'Send',
    checkYourEmail: 'Check your Email',
    sentDesc: 'Please check the email address',
    sentDesc2: 'for instructions to reset your password.',
    isNotFounded: 'Email not found. Try again!',
    wrongEmail: 'Wrong email?',
    enterAgain: 'Enter again!',
  },
  authRecoveryPassword: {
    createNewPassword: 'Create a password',
    password: 'Password',
    createNewPasswordDesc: 'Type new password and confirm it',
    create: 'Create',
    first: 'New Password',
    second: 'Repeat',
    titleOfDemands: 'Your Password must to consist of:',
    lengthDemand: 'minimum 8 characters',
    capitalDemand: 'one capital letter',
    lowercaseDemand: 'one lowercase letter',
    numberDemand: 'one digit (0-9)',
    symbolDemand: 'one character (!@#$%^&*.)',
    example: 'Example:',
    exampleSymbols: 'Vtlq3*fsdfhqwj*',
    length: '8',
    generatePassword: 'Generate password',
    sameField: 'Passwords must match',
    linkExpired: 'The link has expired',
    linkExpiredDesc: 'Please request a new one from your administrator.',
    contactAdmin: 'Contact administrator',
  },
  error: {
    invalid: '{name} is invalid',
    required: '{name} required',
    requiredIf: '{name} required',
    requiredField: 'Required',
    email: 'Wrong Email format',
    maxLength: 'Max length - {length} symbols',
    minLength: 'Min length - {length} symbols',
    maxValue: 'Max value: {value}',
    minValue: 'Min value: {value}',
    onlyNumbers: 'Only numbers',
    onlyIntegerNumbers: 'Only integer numbers',
    onlyIntegerPositiveNumbers: 'Only integer positive numbers',
    onlyWords: 'Only words',
    invalidFileFormat: 'Only .xlsx files are allowed',
    maxFileSize: 'File size must not exceed {size} MB',
    dateOutOfRange: 'Selected month is outside the allowed period',
    noLeadingZero: 'Value cannot start with 0',
    greaterThanZero: 'Value must be greater than 0',
    allow: 'Your password should contain: ',
    sameField: 'Passwords should be the same',
    regexPassword: 'Wrong password format',
    url: 'Wrong URL',
    cloudflare:
      'The request exceeded Cloudflare’s 100-second limit (error 524). Please contact your IT support team to resolve this issue.',
    domainUrl: 'Domain URL must start with "https://"',
    dateFromLess: 'Date "from" should be less than date "to"',
    dateToLess: 'Date "to" should be greater than date "from"',
    commaSpaceRule: "Start and end of field shouldn't contain space or comma",
    lengthDemand: 'Minimum 8 characters',
    capitalDemand: 'Upper case letters (A-Z)',
    lowercaseDemand: 'Lower case letters (a-z)',
    numberDemand: 'Numbers (0-9)',
    symbolDemand: 'Special characters (e.g. !@#$%^&*)',
    latinDemand: 'Password contains only latin letters',
    latinSymbols: 'Cyrillic characters are not allowed',
    invalidValue: 'Wrong value',
    notBeEmpty: "Value shouldn't be empty",
    error403Title: '403!',
    error403Desc: "Page doesn't exists or you don't have access.",
    error404Title: '404!',
    error404Desc:
      'Something seems to have gone wrong! The page you are requesting does not exist. Maybe it is outdated or deleted.',
    emailExist: 'This email is already registered',
    duplicateEntries: 'Duplicate entries. Already used here: ',
    noData: 'Please use filters to generate the report',
    noDataTable: 'Please use filters to generate the table',
    noDataAvailable: 'No Data Available',
    noDataBtnSetPercentage: 'Please use filters to generate the table and set percentage',
    noDataDesc:
      'It looks like there is no data to display at the moment. Please use <br>the filter options to customize and generate your statistics.',
    noDataDescMobile:
      'It looks like there is no data to display at the moment. Please use the filter options to customize and generate your statistics.',
    systemUpdate: 'System Update',
    systemUpdateDesc:
      'A new version of the system has been deployed. To ensure optimal performance and to load the latest features, please refresh your page.',
    refreshPage: 'Refresh page',
    noMatchingOffers: 'No matching offers found',
    noMatchingOffersDesc:
      'There are currently no offers matching your selected criteria, and no offers missing any default landings for the selected streams.',
    slugs: {
      active_rule_for_stream_and_country_exists:
        'An active replacement rule for this stream and original country already exists.',
    },
  },
  lang: {
    ru: 'Russian',
    en: 'English',
  },
}

export default locale
